import { Configuration2D } from 'src/app/models/configurators-2d/configuration2d';
import { BaseAppService } from 'src/app/services/configurators-2d/base-app-service';
import { BaseItem } from './base-item';

export abstract class ConfiguratorItem<C extends Configuration2D, S extends BaseAppService<C>> extends BaseItem<C, S> {}
